import {
  GeneralIcon,
  EducationIcon,
  HealthIcon,
  MembersIcon,
  HousingIcon,
  IncomeIcon,
  NutritionIcon,
  PregnancyIcon,
} from 'components/Icons/IconsSections'
import { type NumberAlertsPerSectionsType } from 'context/hooks/useFamily'

export const contentButton = (
  numberSectionRecommendations: NumberAlertsPerSectionsType
) => [
  {
    title: 'Geral',
    icon: <GeneralIcon />,
    param: 'geral',
  },
  {
    title: 'Membros',
    icon: <MembersIcon />,
    param: 'membros',
  },
  {
    title: 'Renda',
    icon: <IncomeIcon />,
    param: 'renda',
    alert: numberSectionRecommendations.income,
  },
  {
    title: 'Educação',
    icon: <EducationIcon />,
    param: 'educacao',
    alert: numberSectionRecommendations.education,
  },
  {
    title: 'Habitação',
    icon: <HousingIcon />,
    param: 'habitacao',
    alert: numberSectionRecommendations.residence,
  },
  {
    title: 'Saúde',
    icon: <HealthIcon />,
    param: 'saude',
    alert: numberSectionRecommendations.health,
  },
  {
    title: 'Gravidez',
    icon: <PregnancyIcon />,
    param: 'gravidez',
    alert: numberSectionRecommendations.pregnancy,
  },
  {
    title: 'Nutrição',
    icon: <NutritionIcon />,
    param: 'nutricao',
    alert: numberSectionRecommendations.nutrition,
  },
]
